import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof console !== 'undefined') {
      console.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24 }}>
          <h2 style={{ marginTop: 0 }}>Es ist ein Fehler aufgetreten</h2>
          <div style={{ color: '#f87171' }}>{String(this.state.error?.message || this.state.error || 'Unbekannter Fehler')}</div>
          <div style={{ marginTop: 12 }}>
            <a href="/events">Zurück zur Eventübersicht</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
